import { updateGoalViewState, fetchData } from '../FinancialPlanActions';
import fetchWithDefaults from '../../CommonUtils/fetchWithDefaults';
import { httpBodyOptions } from '../../CommonUtils/httpBodyOptions';

export const onAddActionSteps = (clientId, fpId, goalId, Index) => dispatch => {
  dispatch(
    updateGoalViewState(goalId, clientId, {
      isAddingActionStep: true,
      addActionStep: {
        Text: '',
        Icon: 0,
        Index,
      },
    }),
  );
};

export const onResetActionSteps = (clientId, fpId, goalId) => async dispatch => {
  await fetchWithDefaults('/Consumer/UpdatePlanActionSteps/Reset', {
    showSpinner: true,
    method: 'POST',
    ...httpBodyOptions({
      GoalId: goalId,
      clientId,
      fpId,
    }),
  });

  dispatch(
    fetchData(fpId, clientId, true, () => {
      dispatch(
        updateGoalViewState(goalId, clientId, {
          isAddingActionStep: false,
        }),
      );
    }),
  );
};

export const onDeleteActionStep = (clientId, fpId, goalId, ActionStepKey) => async dispatch => {
  await fetchWithDefaults('/Consumer/UpdatePlanActionSteps/Remove', {
    showSpinner: true,
    method: 'POST',
    ...httpBodyOptions({
      GoalId: goalId,
      clientId,
      fpId,
      ActionStepKey,
    }),
  });

  dispatch(fetchData(fpId, clientId, true, () => {}));
};

export const onChangeActionStepStatus = (
  clientId,
  fpId,
  goalId,
  updatedActionStep,
) => async dispatch => {
  await fetchWithDefaults('/Consumer/UpdatePlanActionSteps/UpdateTaskState', {
    showSpinner: true,
    method: 'POST',
    ...httpBodyOptions(
      {
        GoalId: goalId,
        clientId,
        fpId,
        ...updatedActionStep,
      },
      true,
    ),
  });

  dispatch(fetchData(fpId, clientId, true, () => {}));
};

export const onAddSuggestions = (clientId, fpId, goalId) => dispatch => {
  dispatch(
    updateGoalViewState(goalId, clientId, {
      isAddingSuggestion: true,
      addSuggestion: {
        Text: '',
        Icon: 0,
        Index: 0,
      },
    }),
  );
};

export const onResetSuggestions = (clientId, fpId, goalId) => async dispatch => {
  await fetchWithDefaults('/Consumer/UpdatePlanActionSteps/Reset', {
    showSpinner: true,
    method: 'POST',
    ...httpBodyOptions({
      GoalId: goalId,
      clientId,
      fpId,
    }),
  });

  dispatch(
    fetchData(fpId, clientId, true, () => {
      dispatch(
        updateGoalViewState(goalId, clientId, {
          isAddingSuggestion: false,
        }),
      );
    }),
  );
};

export const onDeleteSuggestion = (clientId, fpId, goalId, ActionStepKey) => async dispatch => {
  await fetchWithDefaults('/Consumer/UpdatePlanActionSteps/Remove', {
    showSpinner: true,
    method: 'POST',
    ...httpBodyOptions({
      GoalId: goalId,
      clientId,
      fpId,
      ActionStepKey,
    }),
  });

  dispatch(fetchData(fpId, clientId, true, () => {}));
};

export const setActionStepIcon = (clientId, fpId, goalId, icon) => dispatch => {
  dispatch(
    updateGoalViewState(goalId, clientId, {
      addActionStep: {
        Icon: icon,
      },
    }),
  );
};
export const setActionStepText = (clientId, fpId, goalId, text) => dispatch => {
  dispatch(
    updateGoalViewState(goalId, clientId, {
      addActionStep: {
        Text: text,
      },
    }),
  );
};

export const onDoneAddingActionStep = (
  clientId,
  fpId,
  goalId,
  actionStep,
  DebtType,
) => async dispatch => {
  await fetchWithDefaults('/Consumer/UpdatePlanActionSteps/Create', {
    showSpinner: true,
    method: 'POST',
    ...httpBodyOptions(
      {
        GoalId: goalId,
        clientId,
        fpId,
        ...actionStep,
        DebtType,
      },
      true,
    ),
  });

  dispatch(
    fetchData(fpId, clientId, true, () => {
      dispatch(
        updateGoalViewState(goalId, clientId, {
          isAddingActionStep: false,
        }),
      );
    }),
  );
};

export const onDoneEditingActionStep = (clientId, fpId, goalId, actionStep) => async dispatch => {
  await fetchWithDefaults('/Consumer/UpdatePlanActionSteps/Update', {
    method: 'POST',
    ...httpBodyOptions(
      {
        GoalId: goalId,
        clientId,
        fpId,
        ...actionStep,
      },
      true,
    ),
  });

  dispatch(fetchData(fpId, clientId, true));
};

export const onCancelAddingActionStep = (clientId, fpId, goalId) => dispatch => {
  dispatch(
    updateGoalViewState(goalId, clientId, {
      isAddingActionStep: false,
      addActionStep: null,
    }),
  );
};
export const setSuggestionIcon = (clientId, fpId, goalId, icon) => dispatch => {
  dispatch(
    updateGoalViewState(goalId, clientId, {
      addSuggestion: {
        Icon: icon,
      },
    }),
  );
};
export const setSuggestionText = (clientId, fpId, goalId, text) => dispatch => {
  dispatch(
    updateGoalViewState(goalId, clientId, {
      addSuggestion: {
        Text: text,
      },
    }),
  );
};

export const onDoneAddingSuggestion = (
  clientId,
  fpId,
  goalId,
  suggestionObj,
  suggestions,
  DebtType,
) => async dispatch => {
  const suggestion = { ...suggestionObj, Id: undefined, DebtType };

  await fetchWithDefaults('/Consumer/UpdatePlanActionSteps/SaveAdditionalTips', {
    showSpinner: true,
    method: 'POST',
    ...httpBodyOptions(
      {
        GoalId: goalId,
        clientId,
        fpId,
        AdditionalTips: [suggestion].concat(suggestions),
      },
      true,
    ),
  });

  dispatch(
    fetchData(fpId, clientId, true, () => {
      dispatch(
        updateGoalViewState(goalId, clientId, {
          isAddingSuggestion: false,
        }),
      );
    }),
  );
};
export const onCancelAddingSuggestion = (clientId, fpId, goalId) => dispatch => {
  dispatch(
    updateGoalViewState(goalId, clientId, {
      isAddingSuggestion: false,
      addSuggestion: null,
    }),
  );
};
